import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { ChartModel } from '../../models/chart.model';
import { ReportBlockTypeEnum } from '../../../Reports/enums/report-block-type.enum';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { SeriesModel } from '../../models/series.model';
import { DataListChartOptionsModel } from '../../models/data-list-chart-options.model';
import { ChartSpecificTypesEnum } from '../../../Reports/enums/chart-specific-types.enum';
import { EntityType } from '../../../../api/targeting/enum/entity.type.enum';
import { CornerRadiusModel } from '../../../PageBuilder/models/corner-radius.model';
import { Am5Chart } from '../../../../Common/Charts/models/am5-chart.model';
import { ReportSeriesModel } from '../../../../Common/Reports/models/report-series.model';
import { am5BlockTypes } from '../../../../Common/Reports/models/new-data-processing-workflow-block-types.model';
import { Am5ChartComponent } from '../Am5Chart/am5-chart.component';


@Component({
    selector: 'agpr-canvas-chart',
    templateUrl: './canvas-chart.component.html',
    styleUrls: ['./canvas-chart.component.scss'],
    standalone: false
})
export class CanvasChartComponent implements OnChanges {
    readonly reportBlockTypeEnum = ReportBlockTypeEnum;
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly chartSpecificTypesEnum = ChartSpecificTypesEnum;
    readonly entityTypes = EntityType;
    readonly am5BlockTypes = am5BlockTypes;

    @Input() data: any;
    @Input() nonAmChartSeries: SeriesModel[] = [];
    @Input() dataListChartOptions: DataListChartOptionsModel = {};
    @Input() topTermChartOptions: any = {};
    @Input() type: string;
    @Input() chart: ChartModel;
    @Input() reportSeries: ReportSeriesModel[];
    @Input() width: number;
    @Input() height: number;
    @Input() am5Chart: Am5Chart;
    @Input() useDisplayElementDateRangeLabel: boolean = false;

    @Output() noData: EventEmitter<boolean> = new EventEmitter(false);

    @ViewChild('am5ChartComponent') am5ChartComponent: Am5ChartComponent;

    constructor(public changeDetectorRef: ChangeDetectorRef) {}

    ngOnChanges(): void {
        // used in BMIE for old briefings that were created before corner radius was added to chart styles
        if (this.data?.styles && !this.data.styles.cornerRadius) {
            this.data.styles.cornerRadius = new CornerRadiusModel(12, false);
        }
    }

    updateNoData(value: boolean): void {
        this.noData.emit(value);
    }

    setChartAnnotations(): Promise<void> {
        return this.am5ChartComponent.setChartAnnotations();
    }
}
